import { Valence } from '../api/client'

/** The valences a classifier can have, in display order. */
export const VALENCE_OPTIONS: { value: Valence; label: string }[] = [
    { value: Valence.Negative, label: 'Negative' },
    { value: Valence.Neutral, label: 'Neutral' },
    { value: Valence.Positive, label: 'Positive' }
]
